import React, { ReactNode } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './Activity.module.scss'

interface ActivityProps {
  image: ReactNode
  caption: ReactNode
}
const Activity: React.FC<ActivityProps> = ({ image, caption }: ActivityProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.image}>
        {image}

        <StaticImage
          width={297}
          height={216}
          src='./assets/activity-overlay.png'
          alt=''
          className={styles.overlay}
          style={{ position: 'absolute' }}
        />
      </div>
      <div className={styles.caption}>
        {caption}
      </div>
    </div>
  )
}

export default Activity
